
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";
import { encodeCrosswordClue } from "@utils";
import { AD_LAYOUT_STUBS } from "@consts";

dayjs.extend(utc);
dayjs.extend(tz);
export default {
	name: "CrosswordPublisher",
	middleware: "crossword-publisher",
	asyncData({ res }) {
		// Set cache expiration header:
		if (process.server && res) {
			const now = dayjs().tz("America/New_York");
			const expirationDate = now
				.endOf("day")
				.utc()
				.format("ddd, DD MMM YYYY HH:mm:ss [GMT]");

			res.setHeader("Expires", expirationDate);
		}

		return {
			serverDate: dayjs().format("YYYY-MM-DD"),
		};
	},
	data() {
		return {
			AD_LAYOUT_STUBS,
			loading: false,
			clues: {
				across: [],
				down: [],
			},
		};
	},
	async fetch() {
		await this.fetchData();
	},
	head({ $buildMetaDataObject }) {
		return $buildMetaDataObject({
			title: `New York Times Crossword Answers | ${dayjs().format(
				"MMMM D, YYYY"
			)}`,
			description:
				"Find all the answers to today's New York Times crossword puzzle. Updated daily!",
		});
	},
	computed: {
		// This ensures that the directions are always in the correct order.
		clueGroups() {
			const groups = [];

			["across", "down"].forEach((direction) => {
				if (!this.clues?.[direction]?.length) {
					return;
				}

				const pathBase = `/crosswords/${this.$route?.params?.publisher}`;
				groups.push({
					direction,
					clues: (this.clues?.[direction] || []).map((clue) => ({
						...clue,
						path: `${pathBase}/${encodeCrosswordClue(clue.clue)}`,
					})),
				});
			});

			return groups;
		},
	},
	mounted() {
		const clientDate = dayjs().format("YYYY-MM-DD");
		if (clientDate !== this.serverDate) {
			this.fetchData(clientDate);
		}
	},
	methods: {
		getCrosswordIdFromPublisherSlug() {
			const publisherSlug = this.$route?.params?.publisher;

			switch (publisherSlug) {
				case "new-york-times-crossword":
					return "NYT-CROS";
			}

			return "NYT-CROS";
		},
		getDailyCrosswordTitle() {
			const date = dayjs();

			return `NYT&nbsp;-&nbsp;${date.format("MMMM")}&nbsp;${date.format(
				"D"
			)}, ${date.format("YYYY")}&nbsp;Crossword&nbsp;Clues`;
		},
		async fetchData(date = null) {
			date = date || dayjs().format("YYYY-MM-DD");

			const requestPromise = new Promise((resolve) => {
				this.loading = true;
				const request = this.$axios.get(
					`${this.$config.CWH_API_SERVICE}/daily-crosswords/v1/crossword`,
					{
						responseType: "json",
						params: {
							crosswordId: this.getCrosswordIdFromPublisherSlug(),
							date,
						},
					}
				);

				request.then(({ data }) => {
					this.onFetch(data);
					this.loading = false;
					resolve();
				});
			});

			if (process.server) {
				await requestPromise;
			}
		},
		onFetch(data) {
			try {
				const { answers } = data.crossword || {};
				const { across, down } = answers;

				this.clues.across = across;
				this.clues.down = down;
			} catch (e) {
				console.error(
					"Error occurred while loading crossword publisher data",
					e
				);
			}
		},
	},
};
